import { computed } from 'vue'
import { subtractBusinessDays } from '../components/Reminders/dateUtils.js'


export function useBusinessDaysReminder(eventDefinition, actualPlanYear, yearOfActualPlan) {
  
  function getBusinessDaysBetween(startDate, endDate) {
    let count = 0
    const current = new Date(startDate)
    
    while (current <= endDate) {
      const dayOfWeek = current.getDay()
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        count++
      }
      current.setDate(current.getDate() + 1)
    }
    
    return count
  }

  const reminderDaysOption = computed(() => {
    const currentEvent = eventDefinition.value
    const planYear = actualPlanYear.value
    const yearPlan = yearOfActualPlan.value
    

    const baseOptions = [
      { value: 0, text: 'Today' },
      { value: 1, text: '1 day before' },
      { value: 3, text: '3 days before' },
      { value: 5, text: '5 days before' },
      { value: 10, text: '10 days before' },
      { value: -1, text: 'Custom date' }
    ]

    if (!currentEvent || !currentEvent.date) {
      return baseOptions.map(option => ({ ...option, disabled: false }))
    }

    const today = new Date()
    today.setHours(0, 0, 0, 0)
    
    let dueDate
    
    if (currentEvent.date && typeof currentEvent.date === 'string') {
      const [month, day] = currentEvent.date.split('/').map(Number)
      
      if (planYear?.plan_start_date && yearPlan) {
        const [planMonth, planDay, planYearNum] = planYear.plan_start_date.split('/').map(Number)
        const planStartDate = new Date(planYearNum, planMonth - 1, planDay)
        
        dueDate = new Date(planYearNum, month - 1, day)
        
        if (dueDate < planStartDate) {
          dueDate.setFullYear(planYearNum + 1)
        }
      } else {
        const currentYear = new Date().getFullYear()
        dueDate = new Date(currentYear, month - 1, day)
        
        if (dueDate < today) {
          dueDate.setFullYear(currentYear + 1)
        }
      }
    } else {
      return baseOptions.map(option => ({ ...option, disabled: false }))
    }
    
    dueDate.setHours(0, 0, 0, 0)


    return baseOptions.map((option) => {
      if (option.value === -1 || option.value === 0) {
        return {
          ...option,
          disabled: false,
          isDisabled: () => false
        }
      }
      
      const reminderDate = subtractBusinessDays(dueDate, option.value)
      const shouldDisable = reminderDate < today
      
      
      return {
        ...option,
        disabled: shouldDisable,
        isDisabled: () => shouldDisable
      }
    })
  })

  return {
    reminderDaysOption,
    getBusinessDaysBetween,
    subtractBusinessDays
  }
}